/**
 * Increments in place the given date by the number of business days specified
 * @param date - the Date object to mutate
 * @param daysToIncrement - the number of business days to increment the date by
 * @returns void
 */
export default function addBusinessDays(
  date: Date,
  daysToIncrement: number
): void {
  for (let i = 0; i < daysToIncrement; i++) {
    date.setDate(date.getDate() + 1);
    while ([0, 6].includes(date.getDay())) {
      date.setDate(date.getDate() + 1);
    }
  }
}
